<div class="container admin">
  <h1>{{ 'admin.i18n.poeditor.title' | translate }}</h1>
  <div class="row">
    <div class="col-sm-2">
      <button class="btn btn-default" (click)="export()">
        {{ 'admin.i18n.export' | translate }}
      </button>
    </div>
    <div class="col-sm-2">
      <button class="btn btn-default" (click)="chooseFile()">
        {{ 'admin.i18n.convert' | translate }}
      </button>
      <input class="hidden" type="file" accept=".xlsx" #fileInput (change)="importFile($event)"/>
    </div>
  </div>
</div>
